import React from 'react';
import { Flex, Text, styled, css } from '@goodrx/matisse';

export const StyledLineItem = styled(Flex)`
  flex-direction: row;
  align-items: center;
  font-weight: 500;
  margin-bottom: ${(p) => p.theme.space[3]}px;
`;

const LineTitle = styled(Text)(
  ({ theme }) => css`
    flex: 1;
    color: ${theme.colors.black};
  `
);

const LineContent = styled(LineTitle)`
  ${({ theme }) => css`
    max-width: 300px;
    text-align: right;
    color: ${theme.colors.greyDarker};
  `}
`;

export const LineItem: React.FC<{ title: string | JSX.Element; content: string | JSX.Element }> = ({
  title,
  content,
}) => (
  <StyledLineItem>
    <LineTitle>{title}</LineTitle>
    <LineContent>{content}</LineContent>
  </StyledLineItem>
);
